import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createReportTemplateFailed, createReportTemplateSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createReportTemplate(action) {
  try {
    const url = `${BACKEND_URL}/resources/report-templates`;
    const response = yield makeRequest(url, action.payload, action, 'POST', true);
    if (response.status === CREATED) {
      yield put(createReportTemplateSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(createReportTemplateFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createReportTemplateFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
